package com.neurobs.js.ccab

import com.neurobs.ccab.{CCABServer => NewCCABServer}
import com.neurobs.http.URLUtils
import com.neurobs.js.http.XMLHttpRequestSession

import scala.concurrent.ExecutionContext.Implicits.global
import scala.scalajs.js.URIUtils

object RelativeJSCCABServer {
	private implicit val urlEncoder = new URLUtils {
		override def encode(s: String): String = URIUtils.encodeURI(s)
	}
	def apply(): NewCCABServer = {
		val session = new XMLHttpRequestSession
		session.setCommonHeaders(Seq(("Csrf-Token", "nocheck")))
		new NewCCABServer(NewCCABServer.relativeServer, session)
	}
}
